<template>
  <v-container>
    <template
      v-if="
        equipmentProfile.variables[index].type !== 'deathLine' &&
          equipmentProfile.variables[index].type !== 'steps'
      "
    >
      <div class="d-flex justify-space-between align-center mb-12">
        <v-text-field
          filled
          style="max-width:100px"
          v-model.number="equipmentProfile.variables[index].min"
          :label="`Min (${unit})`"
          type="number"
          step=".01"
        ></v-text-field>
        <v-text-field
          filled
          style="max-width:100px"
          v-model.number="equipmentProfile.variables[index].max"
          :label="`Max ${unit}`"
          type="number"
          step=".01"
        ></v-text-field>
      </div>
      <vue-slider
        class="mt-4"
        tooltip="always"
        ref="slider"
        :interval="0.1"
        :min="parseFloat(min)"
        :max="parseFloat(max)"
        :tooltip-formatter="formatter1"
        v-model="equipmentProfile.variables[index].values"
        v-bind="options"
        :lazy="true"
      ></vue-slider>
    </template>
    <template
      v-else-if="equipmentProfile.variables[index].type === 'deathLine'"
    >
      <div class="d-flex justify-end align-center mb-12">
        <v-text-field
          filled
          style="max-width:100px"
          v-model.number="deathLineMax"
          :value="formatTime(equipmentProfile.variables[index].max)"
          :label="`Max months`"
          type="number"
          @change="saveMax"
          step="1"
        ></v-text-field>
      </div>
      <vue-slider
        class="mt-4"
        tooltip="always"
        ref="slider"
        :interval="2592000"
        :min="parseFloat(min)"
        :max="2592000 * deathLineMax"
        :tooltip-formatter="formatTime"
        v-model="equipmentProfile.variables[index].values"
        v-bind="options"
        :lazy="true"
      ></vue-slider>
    </template>

    <div v-else-if="equipmentProfile.variables[index].type === 'steps'">
      <v-alert border="bottom" colored-border type="warning" elevation="2">
        The use of alarms for this type of variables is currently developing
      </v-alert>
    </div>
  </v-container>
</template>

<script>
import { unitDefault } from "@/settings/unitTypes";
import { mapState, mapGetters } from "vuex";
import "vue-slider-component/theme/antd.css";
export default {
  components: {
    "vue-slider": () => import("vue-slider-component")
  },
  props: {
    index: {
      type: Number,
      default: 99
    }
  },

  watch: {},
  computed: {
    variable() {
      return this.equipmentProfile?.variables[this.index];
    },
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapGetters("auth", ["isMetric"]),

    max() {
      return parseFloat(
        this.equipmentProfile?.variables[this.index]?.max
      ).toFixed(1);
    },
    min() {
      return parseFloat(
        this.equipmentProfile?.variables[this.index]?.min
      ).toFixed(1);
    },
    unit() {
      return this.isMetric
        ? unitDefault[this.variable.type].metric
        : unitDefault[this.variable.type].imperial;
    }
  },
  data() {
    return {
      deathLineMax: 15552000,
      options: {
        process: pos => [
          [pos[0], pos[1], { backgroundColor: "#e7b416" }],
          [pos[1], pos[2], { backgroundColor: "#2dc937" }],
          [pos[2], pos[3], { backgroundColor: "#e7b416" }]
        ],
        railStyle: { backgroundColor: "#cc3232" },
        enableCross: true,
        tooltipStyle: { backgroundColor: "#C72A23" }
      }
      /*     marksStability: {
        "0": this.$t("flame.highDispersion"),
        "1": this.$t("flame.semiFocused"),
        "2": this.$t("flame.focused")
      },
      marksColors: {
        "0": this.$t("flame.red"),
        "1": this.$t("flame.orange"),
        "2": this.$t("flame.yellow"),
        "3": this.$t("flame.blue")
      } */
    };
  },
  async created() {
    this.deathLineMax = this.formatTime(
      this.equipmentProfile?.variables[this.index]?.max
    );
  },
  methods: {
    formatter1(value) {
      return `${value} ${this.unit}`;
    },
    setUnit(item) {
      // Selecciona el Unit por defecto segun el perfil del usuario
      return this.isMetric
        ? unitDefault[item].metric
        : unitDefault[item].imperial;
    },
    formatTime(maxInSeconds) {
      return maxInSeconds / 2592000;
    },
    saveMax(months) {
      this.equipmentProfile.variables[this.index].max = months * 2592000;
    }
  }
};
</script>
